import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from '../../../services/auth/auth-session.service';

const requireAuthenticatedSession = (): boolean | ReturnType<Router['createUrlTree']> => {
  const session = inject(AuthSessionService);
  const router = inject(Router);
  return session.isAuthenticated() ? true : router.createUrlTree(['/welcome']);
};

export const authGuard: CanActivateFn = () => requireAuthenticatedSession();
export const authChildGuard: CanActivateChildFn = () => requireAuthenticatedSession();
